export var REQUEST_CHECK_CAMPAIGN_CODE = 'REQUEST_CHECK_CAMPAIGN_CODE';
export var SUCCESS_CHECK_CAMPAIGN_CODE = 'SUCCESS_CHECK_CAMPAIGN_CODE';
export var FAILURE_CHECK_CAMPAIGN_CODE = 'FAILURE_CHECK_CAMPAIGN_CODE';
export var CLEAR_CHECK_CAMPAIGN_CODE = 'CLEAR_CHECK_CAMPAIGN_CODE';